import { render } from "./ComparisonTemplates.vue?vue&type=template&id=4fae44c6&scoped=true"
import script from "./ComparisonTemplates.vue?vue&type=script&lang=js"
export * from "./ComparisonTemplates.vue?vue&type=script&lang=js"

import "./ComparisonTemplates.vue?vue&type=style&index=0&id=4fae44c6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fae44c6"]])

export default __exports__